import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico'
import type { ManagerClass, RawGroupsResponse } from '../interfaces'
import { toManagerClass } from '../helpers'

/**
 * Fetch the school classes visible to the current manager.
 * Contract: GET /api/arc_mosaico/groups → { groups: RawGroup[], pagination? }.
 * The manager profile is not tutor-filtered, so this returns the whole school.
 */
export const fetchManagerClasses = async (): Promise<ManagerClass[]> => {
  const response = await api.get<RawGroupsResponse>(ARC_MOSAICO_ENDPOINTS.groups.list)
  const groups = response.data?.groups
  return Array.isArray(groups) ? groups.map(toManagerClass) : []
}
